import { Separator } from '../../atoms/Separator/Separator';
import { LatestUserReview } from '../LatestUserReview/LatestUserReview';
import { LicensingTable } from '../LicensingTable/LicensingTable';
import { ProductCompatibilityTable } from '../ProductCompatibilityTable/ProductCompatibilityTable';
import { PublisherInfoTable } from '../PublisherInfoTable/PublisherInfoTable';
import { ProductNutritionLabelsProps } from './ProductNutritionLabels.types';

export const ProductNutritionLabels = ({
  compatibility,
  licensing,
  publisher,
  latestUserReview,
  microcopy,
  className = '',
}: ProductNutritionLabelsProps) => {
  const separatorClassName = 'mt-8 mb-4';
  return (
    <div className={className}>
      <Separator className="hidden md:block" />
      <ProductCompatibilityTable
        {...compatibility}
        microcopy={microcopy.compatibility}
      />
      <Separator className={separatorClassName} />
      <LicensingTable {...licensing} microcopy={microcopy.licensing} />
      {latestUserReview && microcopy.latestUserReview && (
        <>
          <Separator className={separatorClassName} />
          <LatestUserReview
            {...latestUserReview}
            microcopy={microcopy.latestUserReview}
          />
        </>
      )}
      <Separator className={separatorClassName} />
      <PublisherInfoTable {...publisher} microcopy={microcopy.publisher} />
    </div>
  );
};
